import BaseApi from '../BaseApi';
import { CbuPaymentsConverter } from './CbuPaymentsConverter';

class CbuPaymentsApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api`;
    this.converter = new CbuPaymentsConverter();
  }

  setCBU = ({ cbu }) =>
    this.sendQuery(this.queryTypes.PUT, `${this.baseUrl}/user/profile/additional/cbu`, { cbu }, null, d => d.card);

  getCBU = () => this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/payment/admin/requisite`, null, null, d => d.cbu);

  getPlayerDeposits = ({ date_from, date_to, count, page, username, id, type }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/agent_admin/payment`,
      { date_from, date_to, count, page, username, id, type },
      null,
      this.converter.convertRequests,
    );

  changePlayerDeposit = ({ type, id, status }) =>
    this.sendQuery(this.queryTypes.PATCH, `${this.baseUrl}/payment/${type}/${id}`, { status });

  setDepositBonusPercent = ({ id, bonus_percent }) =>
    this.sendQuery(this.queryTypes.PATCH, `${this.baseUrl}/agent_admin/payment/${id}`, { bonus_percent });

  createBank = ({ titular, bank, details }) =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/agent_admin/bank/`, { titular, bank, details });

  updateBank = ({ id, titular, bank, details }) =>
    this.sendQuery(this.queryTypes.PATCH, `${this.baseUrl}/agent_admin/bank/${id}/`, { titular, bank, details });

  deleteBank = ({ id }) => this.sendQuery(this.queryTypes.DELETE, `${this.baseUrl}/agent_admin/bank/${id}/`, null);
}

export default CbuPaymentsApi;
